

export class Anomalies{

  Qn_Num : number;
  Rule : string;
  Msg : string;
  Msg_S : string;
  Msg_H : string;



  //For my use
  dispValue : string;
}



// WEBPACK FOOTER //
// ./src/app/classes/anomaly.ts